import { BaseController } from '../../../../common/base/controller';
import { FormRule } from '../../../../common/ui/form/FormRule';
import _ from 'lodash';

export class StandingOrderFormController extends BaseController {
  constructor(
    controllerService,
    inputFormService,
    standingOrderFormFields,
    dataParser,
    clipboard,
    $scope,
    $compile,
  ) {
    'ngInject';
    super({
      controllerService,
      inputFormService,
      standingOrderFormFields,
      dataParser,
      clipboard,
      $scope,
      $compile,
    });
  }

  $onInit() {
    if (this.copyToClipboard) {
      this.clipboardTooltips = {};
    }

    // Define form rules
    this.formRules = {
      nextExecution: new FormRule(this.nextExecutionRule()),
    };

    // Initialize fields when language options has been loaded
    this.setLanguageOptions().then(() => this.setupFields());
    this.bindEvents();
  }

  setupFields() {
    this.fields = this.inputFormService.getFields(
      this.standingOrderFormFields(this.category),
      this.languageOptions,
      this.model,
    );
    this.runFormRuler();
  }

  bindEvents() {
    const { $scope } = this;
    $scope.$on('standingOrders.setupFields', () => this.setupFields());
  }

  onSelect($event) {
    // Copy selected value to clipboard
    if (this.copyToClipboard) {
      this.clipboard.copyText($event.target.value);
      this.clipboardTooltips[$event.target.name] = true;
    }
    $event.target.select();
  }

  runFormRuler() {
    const { $scope, $compile, model, form } = this;
    const injections = { $scope, $compile };

    // Watch every model value which has a defined form rule
    _.forEach(this.formRules, (rule, key) => {
      $scope.$watch(
        `vm.model.${key}`,
        rule.create(form, model, key, injections),
      );
    });
  }

  /**
   * Mirror value of nextExecution to firstExecution if not yet defined
   */
  nextExecutionRule() {
    return (form, model, key, injections, newVal) => {
      if (model && !model.firstExecution) {
        model.firstExecution = newVal;
      }
    };
  }
}
